// Inside a function that draws text on the canvas
export const drawText = (
  context: CanvasRenderingContext2D,
  text: string,
  x: number,
  y: number,
  isArabic: boolean,
) => {
  if (isArabic) {
    context.direction = "rtl";
    context.textAlign = "right"; // Align text to the right for RTL
  } else {
    context.direction = "ltr";
    context.textAlign = "left"; // Default alignment for LTR
  }

  context.fillText(text, x, y);

  // Reset context properties if necessary to avoid affecting subsequent drawings
  context.direction = "ltr";
  context.textAlign = "left";
};
